import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Helmet } from "react-helmet";
import { useQueries } from "react-query";
import { useParams } from "react-router-dom";
import { fetchChallenges, fetchEventDetails } from "../api";
import Preloader from "../components/loader/Preloader";
import Footer from "../components/Main/Footer";
import Header from "../components/Main/Header";
import { SustainathonChallenges } from "../data/Lists";
import EventDetails from "../components/Sustainathons/EventDetails";
import EventJudges from "../components/Sustainathons/EventJudges";
import Partners from "../components/Sustainathons/EventsPartner";
import EventChallenges from "../components/Sustainathons/EventChallenges";
import Errorpage from "../components/Main/Error";
import Eventwebinars from "../components/Sustainathons/EventWebinars";
import Stickbar from "../components/Main/Stickbar";
import { LanguageContext } from "../App";
import TEXT from "../data/text";

const EventsDetail = () => {
  const ChallengeRef = useRef(null);
  const WebinarsRef = useRef(null);
  const handleOnScroll = (e, goWhere) => {
    e.preventDefault();
    if (ChallengeRef && goWhere === "gotoChallenges") {
      ChallengeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    if (WebinarsRef && goWhere === "gotoWebinars") {
      WebinarsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const onHandleParticipate = async (e, ionEventUrl, ionEventId) => {
    e.preventDefault();
    const ionUrl = await ionEventUrl;
    const ionId = await ionEventId;
    // console.log(ionUrl, ionId);
    window.open(
      ionUrl && ionEventId
        ? `${ionUrl}?${ionId}`
        : ionUrl
        ? `${ionUrl}`
        : window.location.reload()
    );
  };

  // To get event id  and status for api call
  const params = useParams();
  let id = params.eventsId;
  let status = params.status;

  if (id === "ANZ2024" && status === "upcoming") {
    status = "ongoing";
  }
  const { language, languages, setLanguages } = useContext(LanguageContext);

  const results = useQueries([
    {
      queryKey: ["eventdetails", id],
      queryFn: async () => {
        const results = await fetchEventDetails(id);
        try {
          let newLanguages = { ENGLISH: "English" };
          results?.translation &&
            Object.keys(results?.translation).forEach((each) => {
              newLanguages[each.toUpperCase()] = each;
            });
          setLanguages(newLanguages);
        } catch (err) {
          return results;
        }
        return results;
      },
      staleTime: 10000,
      refetchOnWindowFocus: false,
    },
    {
      queryKey: ["eventsChallenges", id],
      queryFn: () => fetchChallenges(id),
      staleTime: 10000,
      refetchOnWindowFocus: false,
    },
  ]);

  if (
    results.length < 0 ||
    results[0].status === "error" ||
    results[1].status === "error"
  ) {
    return (
      <Fragment>
        <Header obj={SustainathonChallenges[language]} />
        <p style={{ textAlign: "center" }}>{TEXT[language]["EVENTS"]["14"]}</p>
        <Footer />
      </Fragment>
    );
  }

  if (results[0].isLoading || results[1].isLoading) {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["13"]} </title>
        </Helmet>
        <Preloader />
      </Fragment>
    );
  } else if (
    results[0].isError ||
    results[0].data === "no data" ||
    results[0].data.status !== status
  ) {
    return (
      <Fragment>
        <Helmet>
          <title>{TEXT[language]["EVENTS"]["8"]}</title>
        </Helmet>
        <Errorpage />
      </Fragment>
    );
  } else if (results[0].data) {
    const content0 =
      results[0].data?.translation?.[languages[language]] || results[0].data;
    const content1 = results[1].data;

    return (
      <Fragment>
        <Helmet>
          <title>{content0.title}</title>
        </Helmet>
        <Header
          obj={SustainathonChallenges[language]}
          status={content0.status}
          bgbanner={content0.headerImage}
          head={content0.eventTitle}
          desc={content0.eventHeader}
          handleParticipate={(e) =>
            onHandleParticipate(e, content0.ionEventUrl, content0.ionEventId)
          }
          challengeCheck={content1 && content1.length > 0 ? true : false}
          webinarCheck={
            content0.webinars && content0.webinars.length > 0 ? true : false
          }
          scrollTo={handleOnScroll}
        />
        <Stickbar
          status={status}
          webinarCheck={
            content0.webinars && content0.webinars.length > 0 ? true : false
          }
          challengeCheck={content1 && content1.length > 0 ? true : false}
          contactId={content0.eventMailId}
          handleParticipate={(e) =>
            onHandleParticipate(e, content0.ionEventUrl, content0.ionEventId)
          }
          scrollTo={handleOnScroll}
        />
        <EventDetails eventDetailsData={content0} />
        {content1 && content1.length > 0 ? (
          <EventChallenges myRef={ChallengeRef} ChallengeObj={content1} />
        ) : (
          ""
        )}
        {content0.webinars && content0.webinars.length > 0 ? (
          <Eventwebinars
            eventWebinarsData={content0.webinars}
            myRef={WebinarsRef}
          />
        ) : (
          ""
        )}
        {content0 && content0.judges.length > 0 ? (
          <EventJudges judges={content0.judges} />
        ) : (
          ""
        )}
        {content0.listOfPartners && content0.listOfPartners.length > 0 ? (
          <Partners allPartners={content0.listOfPartners} />
        ) : (
          ""
        )}
        <Footer />
      </Fragment>
    );
  }
};

export default EventsDetail;
